import loadable from 'components/dynamic-import';

export const ConfigureCooldown = loadable(() => import('./ConnectedConfigureCooldown'), true);
